import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { CompanyFormattedNamePipe, PricePipe } from '@lx/shared/ui/pipes';
import { getCompany } from '@lx/shared/tokens';
import { NgForOf, NgIf, NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import { ButtonComponent } from '@lx/shared/ui/button';
import { FlywireGatewayV2Service, PAYMENT_GATEWAY_V2_SERVICE } from '@lx/shared/payment';
import { NavigationService } from '../../../services';
import { QuoteToolLiteStore } from '../../../store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DepositService } from '@lx/quote-tool/shared/services';
import { PaymentInfo } from '../../../types/payment-info.type';
import { LoggerService } from '@lx/shared/logger';

@Component({
  standalone: true,
  selector: 'lx-payment-step',
  templateUrl: './payment-step.component.html',
  styleUrls: ['./payment-step.component.scss'],
  imports: [CompanyFormattedNamePipe, ButtonComponent, NgOptimizedImage, NgForOf, PricePipe, NgIf, NgTemplateOutlet],
  providers: [{ provide: PAYMENT_GATEWAY_V2_SERVICE, useClass: FlywireGatewayV2Service }, DepositService],
})
export class PaymentStepComponent implements OnInit {
  readonly company = getCompany();
  readonly basePath = '/assets/images/qt-payment-';

  readonly paymentOptions = ['visa', 'master', 'digicert'].map((type) => ({
    src: this.basePath + type + '.png',
    alt: `QT payment ${type}`,
  }));

  paymentInfo: PaymentInfo | undefined;

  private readonly paymentGatewayService = inject(PAYMENT_GATEWAY_V2_SERVICE);
  private readonly qtLiteStore = inject(QuoteToolLiteStore);
  private readonly navigationService = inject(NavigationService);
  private readonly logger = inject(LoggerService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.paymentGatewayService.bootstrapV2();
    this.qtLiteStore.paymentInfo$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((info) => {
      this.paymentInfo = info;
    });
  }

  async pay() {
    const { flywireCheckoutSessionData, currentStep } = this.paymentInfo;
    try {
      const result = await this.paymentGatewayService.makePaymentV2(flywireCheckoutSessionData.id);
      if (result.success) {
        this.navigationService.navigateToNextStep(currentStep);
      }
    } catch (e) {
      if (e.errors[0].type === 'cancellation') {
        return;
      }
      this.logger.error('Error during payment:', e);
      this.navigationService.navigateToNextStep(currentStep);
    }
  }
}
